import { Component } from '@angular/core';

@Component({
  selector: 'app-volunteer-service',
  templateUrl: './volunteer-service.component.html',
  styleUrls: ['./volunteer-service.component.scss']
})
export class VolunteerServiceComponent {

}
